import { getCurrentUrlParameter } from 'utils/url';
import { selectDealer } from './dealerSelection';
import { User } from './user';
import logger from 'utils/log';

export async function applyDealerIdFromUrl(user: User): Promise<void> {
  const dealerIdParam = getCurrentUrlParameter('dealerId');

  // Param is entirely absent from the URL — nothing to do
  if (dealerIdParam === undefined) {
    return;
  }

  // Param is present but empty, OR present with a value the user is authorised for
  let shouldCleanUrl = !dealerIdParam;

  if (dealerIdParam && user.dealerIdsList.includes(dealerIdParam)) {
    try {
      await selectDealer(dealerIdParam);
      shouldCleanUrl = true;
    } catch (error) {
      // selectDealer rejected (e.g. invalid brand letter) — leave URL unchanged
      logger.error('[applyDealerIdFromUrl] Failed to apply dealerId from URL', error);
    }
  }

  if (shouldCleanUrl) {
    const url = new URL(window.location.href);
    url.searchParams.delete('dealerId');
    window.history.replaceState(null, '', url.toString());
  }
}
